import {
  Box,
  Button, Card, CardContent,
  CardMedia,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
  Paper,
  Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import Tour from 'reactour';
import styled from 'styled-components';
import logger from 'src/utils/logger';

// Dahili Bileşenler ve Utils
import BeratSVG from 'src/components/Berat';
import GenericAnket from 'src/components/GenericSurvey';
import WelcomeMessage from 'src/components/WelcomeMessage';
import axios from 'src/utils/axios';
import { GetLocation, getTourOpen, getUser, setTourOpen } from 'src/utils/Common';

// Assetler
import PerakendeTV from 'src/assets/images/PerakendeTV.png';
import servisAkademi from 'src/assets/images/servisAkademi.png';
import ArcelikImg from 'src/assets/img/1.png';
import BekoImg from 'src/assets/img/2.png';
import YetkiliServisImg from 'src/assets/img/3.png';
import beratSvg from 'src/assets/img/Berat.png';

// --- SABİTLER ---
const MONTHS_MAP = ["", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

const TOUR_STEPS = [
  { content: <Typography variant="h6">Artemis Uygulamasına Hoşgeldiniz. Yönergeleri Takip Ediniz!</Typography> },
  { selector: '[data-tour="OpenNavbarButton"]', content: <Typography variant="h6">Menüyü Buradan Açabilirsiniz</Typography>, position: 'left' },
  { selector: '[data-tour="LogoutButton"]', content: <Typography variant="h6">Buradan Çıkış Yapabilirsiniz</Typography>, position: 'left' },
  { selector: '[data-tour="ArtemisButton"]', content: <Typography variant="h6">İş Emirlerinize Buradan Ulaşabilirsiniz</Typography>, position: 'left' }
];

const useStyles = makeStyles((theme) => ({
  root: {},
  content: { padding: theme.spacing(2) },
  paperLink: { margin: theme.spacing(0, 1), padding: theme.spacing(1) },
  imageLink: { maxHeight: 70, maxWidth: 150, objectFit: 'contain' },
  bannerImage: { backgroundSize: 'contain', width: '100%' }
}));

const StyledCardMedia = styled(CardMedia)`
  background-size: contain;
`;

// --- ANA BİLEŞEN ---
function Timeline({ className, ...rest }) {
  const classes = useStyles();
  const sessionUser = React.useMemo(() => getUser(), []);
  const bannerId = sessionUser?.BannerId;
  const teknisyenLojistikPrimAktif = sessionUser?.TeknisyenLojistikPrimAktif;
  const teknisyenLojistikPrimDonem = sessionUser?.TeknisyenLojistikPrimDonem;
  const happyBirthday = sessionUser?.HappyBirthday;
  const berat = sessionUser?.Berat;

  // State Yönetimi (Gruplanmış)
  const [tourOpen, setTourStatus] = useState(getTourOpen());
  const [modals, setModals] = useState({
    anket: true,
    birthday: false,
    berat: false,
    primBildiri: false,
    perakendeTV: false
  });

  const [bannerInfo, setBannerInfo] = useState({ image: null, id: null });
  const [primAyText, setPrimAyText] = useState('');

  // Modal Kontrolcüleri
  const toggleModal = (key, value) => setModals(prev => ({ ...prev, [key]: value }));

  const handleCloseBirthday = () => {
    toggleModal('birthday', false);
    if (sessionUser?.TeknisyenLojistikPrimAktif === 1) toggleModal('primBildiri', true);
  };

  useEffect(() => {
    let isMounted = true;

    GetLocation();

    // Prim Bilgisi Ayarla
    if (teknisyenLojistikPrimAktif === 1) {
      setPrimAyText(MONTHS_MAP[teknisyenLojistikPrimDonem] || '');
    }

    // setTimeout ID'lerini sakla
    const timeouts = [];

    // Doğum Günü Kontrolü
    if (Number(happyBirthday) === 1) {
      timeouts.push(setTimeout(() => {
        if (isMounted) toggleModal('birthday', true);
      }, 2000));
    } else if (teknisyenLojistikPrimAktif === 1) {
      if (isMounted) toggleModal('primBildiri', true);
    }

    // Berat Kontrolü
    if (Number(berat) === 1) {
      timeouts.push(setTimeout(() => {
        if (isMounted) toggleModal('berat', true);
      }, 2000));
    }

    // Banner fetch with isMounted check
    const runFetchBanner = async () => {
      if (!bannerId || !isMounted) {
        return;
      }

      try {
        const storedId = localStorage.getItem('BannerId');
        const storedImage = localStorage.getItem('Banner');

        if (storedImage && Number(bannerId) === Number(storedId)) {
          if (isMounted) {
            setBannerInfo({ image: storedImage, id: storedId });
            toggleModal('perakendeTV', true);
          }
          return;
        }

        const response = await axios.get('/GetBanner');
        const responseData = Array.isArray(response?.data) ? response.data : [];

        if (responseData.length > 0 && isMounted) {
          const { Resim, BannerId } = response.data[0];
          localStorage.setItem('Banner', Resim);
          localStorage.setItem('BannerId', BannerId);
          setBannerInfo({ image: Resim, id: BannerId });
          toggleModal('perakendeTV', true);
        }
      } catch (error) {
        logger.warn("Banner yükleme sırasında ağ hatası oluştu:", error.message);
        if (isMounted) {
          toggleModal('perakendeTV', false);
        }
      }
    };

    runFetchBanner();

    // Cleanup function - setTimeout'ları temizle ve isMounted flag'i false yap
    return () => {
      isMounted = false;
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, [bannerId, teknisyenLojistikPrimAktif, teknisyenLojistikPrimDonem, happyBirthday, berat]);

  const openExternalLink = (url) => window.open(url, '_blank', 'noopener,noreferrer');

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      {/* Tour & Anketler */}
      <Tour
        steps={TOUR_STEPS}
        isOpen={tourOpen}
        onRequestClose={() => { setTourOpen(); setTourStatus(false); }}
        accentColor="#FF9800"
        rounded={20}
      />

      {sessionUser?.TechnicianId && (
        <GenericAnket
          anketOpen={modals.anket}
          setAnketOpen={(val) => toggleModal('anket', val)}
          anketTitle="Güne Başlama Anketi"
          anketId={89}
          birimKodu={sessionUser.TechnicianId}
        />
      )}

      <Card className={classes.root}>
        <CardContent>
          <WelcomeMessage
            title="Uyarılar"
            messages={
              (sessionUser && typeof sessionUser.Message === 'string' && sessionUser.Message)
                ? sessionUser.Message.split('\n')
                : []
            }
          />
        </CardContent>
        <Divider />
        <CardContent>
          <Box display="flex" justifyContent="center">
            {[
              { src: servisAkademi, url: "https://servis.arcelikakademi.com/login", alt: "Akademi" },
              { src: PerakendeTV, url: "https://www.perakendetv.net", alt: "PerakendeTV" }
            ].map((link, i) => (
              <Paper key={i} elevation={3} className={classes.paperLink}>
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  <img src={link.src} alt={link.alt} className={classes.imageLink} />
                </a>
              </Paper>
            ))}
          </Box>
        </CardContent>
      </Card>

      {/* MODALLAR */}

      {/* Doğum Günü */}
      <Dialog open={modals.birthday} onClose={handleCloseBirthday}>
        <DialogContent>
          <Confetti />
          <Typography variant="h6">
            Sevgili {sessionUser.NameSurname},<br /><br />
            Doğum gününü kutlar sevdiklerinle birlikte sağlık, mutluluk ve başarılarla dolu nice seneler dilerim.<br /><br />
            İyi ki doğdun!<br /><br />
            Sevgilerimle,<br />
            <b>Hüseyin Şerif Beyaztaş</b><br />
            <Typography variant="caption">Arçelik Müşteri Hizmetleri Kıdemli Direktörü</Typography>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">Tamam</Button>
        </DialogActions>
      </Dialog>

      {/* Banner / Perakende TV */}
      <Dialog
        open={modals.perakendeTV}
        fullScreen
        onClose={() => toggleModal('perakendeTV', false)}
      >
        <DialogTitle>Bilgilendirme</DialogTitle>
        <Divider />
        <DialogContent onClick={() => openExternalLink('https://www.perakendetv.net/detail/F63131EE-B0F8-456A-8A90-FEF4D09ED9FF')}>
          {bannerInfo.image && (
            <StyledCardMedia component="img" src={bannerInfo.image} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => toggleModal('perakendeTV', false)}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      {/* Prim Bildirimi */}
      <Dialog open={modals.primBildiri} onClose={() => toggleModal('primBildiri', false)}>
        <DialogContent>
          <Box p={2} textAlign="center" bgcolor="#f5f5f5" borderRadius={8}>
            <img src="/images/PersonalPrimKutlama.jpeg" alt="Ödül" style={{ width: '100%', borderRadius: 8 }} />
            <Typography variant="h6" color="primary" style={{ marginTop: 16 }}>
              <span role="img" aria-label="Kutlama">🎉</span> 100 Kg Üstü Buzdolabı Hasarsız Nakliye Ödülü! <span role="img" aria-label="Kutlama">🎉</span>
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              Hassasiyetle tamamladığınız teslimatlar sayesinde {primAyText} ayında
              <b> {sessionUser?.TeknisyenLojistikPrimTutar}₺ </b> ödül kazandınız.
              Ödülünüz Bizpuan hesabınıza yatırılmıştır.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleModal('primBildiri', false)} color="primary">Tamam</Button>
        </DialogActions>
      </Dialog>

      {/* Berat Modalı */}
      <Dialog open={modals.berat} onClose={() => toggleModal('berat', false)} fullScreen>
        <DialogContent>
          <Confetti />
          <BeratSVG
            beratSvg={beratSvg}
            ArcelikImg={ArcelikImg}
            YetkiliServisImg={YetkiliServisImg}
            BekoImg={BekoImg}
            txtHeader="Değerli Yetkili Servis"
            SessionUser={sessionUser}
            textStyle1={{ fontSize: '70px', fill: '#B27409' }}
            textStyle2={{ fontSize: '27px', fill: 'rgba(0,0,0,0.8)' }}
            textStyle3={{ fontSize: '31px', fill: 'rgba(178,116,9,0.8)' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleModal('berat', false)} color="primary">Tamam</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;